function toEnglish1(input) {
  // Check if the input is a string consisting of digits
  if (typeof input !== 'string') {
    return ''
  }

  // Replace Persian and Arabic numeric characters with Latin numerals
  input = input.replace(/[۰-۹٠-٩]/g, (match) => {
    const persianOffset = '۰'.charCodeAt(0)
    const arabicOffset = '٠'.charCodeAt(0)
    return String.fromCharCode(
      match.charCodeAt(0) -
        Math.min(persianOffset, arabicOffset) +
        '0'.charCodeAt(0)
    )
  })

  // Extract and return all numeric digits from the input
  const numericPart = input.match(/\d+/)

  if (numericPart) {
    return numericPart.join('')
  } else {
    return ''
  }
}

export const toEnglish = {
  methods: {
    toEnglish(val, notString = true) {
      if (val == undefined || val == '') return

      var e = '۰'.charCodeAt(0)
      val = val.replace(/[۰-۹]/g, function (t) {
        return t.charCodeAt(0) - e
      })

      e = '۰'.charCodeAt(0)
      val = val.replace(/[۰-۹]/g, function (t) {
        return t.charCodeAt(0) - e
      })
      if (notString) return toEnglish1(val)
      else return val
    },
  },
}
